// @flow

import {Loadable} from 'app/components/general/lazyLoader';
import {
  DetailLoadingPage,
  type SPErrorType,
} from 'app/general/loading/DetailLoadingPage';
import {type OwnProps} from './NewProcessEditPage';

export const LoadableProcessEditPage = Loadable<SPErrorType, OwnProps>({
  loader: () =>
    import(/* webpackChunkName: "edit-pages" */ './NewProcessEditPage'),
  LoadingComponent: DetailLoadingPage,
});
